import React from 'react'
import { Container } from './styles'
import { useOncologyHealthProcedures } from '~/context'
import { EMedicalViews, createSelectedPeriodFrom, PeriodOfTime } from '~/interfaces/timeline'
import {
  MedicalViewSelector,
  MedicalEventTypeFilter,
  CalendarFilter,
  TimelinePeriodSelector
} from '~/components/shared/medicalViews'
import { SearchHealthProcedure } from '~/components/healthProcedures/SearchHealthProcedure'
import { Stack } from '~/styles'
import { filterHealthProceduresTypesOncology } from '~/constants/healthProceduresTypes'

export const OncologyHeader = (): JSX.Element => {
  const {
    selectedPeriod,
    updateSelectedPeriod,
    displayedHealthProcedures,
    filterHealthProceduresByTerm,
    hasDateFiltersActive,
    dateFiltersActive,
    handleFilterHealthProceduresPerDate,
    hasTypeFiltersActive,
    typeFiltersActive,
    handleFilterHealthProceduresPerType
  } = useOncologyHealthProcedures()

  return (
    <Container>
      <Stack direction="row" width="100%" justifyContent="space-between">
        <Stack direction="row">
          <TimelinePeriodSelector
            value={selectedPeriod.period}
            onChange={value => updateSelectedPeriod({ ...createSelectedPeriodFrom(value as PeriodOfTime) })}
          />
        </Stack>

        <Stack direction="row" spacing="0.5rem">
          <MedicalViewSelector isActive selectedMedicalView={EMedicalViews.ONCOLOGY} />
          <MedicalEventTypeFilter
            options={filterHealthProceduresTypesOncology}
            selected={typeFiltersActive}
            isActive={hasTypeFiltersActive}
            onChange={handleFilterHealthProceduresPerType}
          />
          <CalendarFilter
            dates={dateFiltersActive}
            isActive={hasDateFiltersActive}
            onChange={handleFilterHealthProceduresPerDate}
          />
        </Stack>
      </Stack>

      <SearchHealthProcedure options={displayedHealthProcedures} handleSearch={filterHealthProceduresByTerm} />
    </Container>
  )
}
